/**
 * 打卡判定依据 / 状态 → i18n key。
 *
 * 这些码由服务端写进 `Punch.reason` 和 `Punch.status`。
 * 显式映射而不是拼字符串：拼出来的 key 少一个翻译不会报错，
 * 只会在界面上显示成 `attendance.reasonFoo` 这种东西。
 *
 * 放在这里是因为管理端考勤页和手机端待办中心都要用，
 * 各存一份迟早会漏掉新增的码。
 */
export const PUNCH_REASON_KEY: Record<string, string> = {
  IN_RANGE: 'attendance.reasonInRange',
  OUT_OF_RANGE: 'attendance.reasonOutOfRange',
  MOCK_LOCATION: 'attendance.reasonMockLocation',
  ACCURACY_TOO_LOW: 'attendance.reasonAccuracyTooLow',
  CLOCK_DRIFT: 'attendance.reasonClockDrift',
  DUPLICATE_IN: 'attendance.reasonDuplicateIn',
  DUPLICATE_OUT: 'attendance.reasonDuplicateOut',
  MANUAL_ADMIN: 'attendance.reasonManual',
  // 定位失败时工人填理由继续打的（CR-015）
  NO_LOCATION_OVERRIDE: 'attendance.reasonNoLocationOverride',
  OUT_OF_RANGE_OVERRIDE: 'attendance.reasonOutOfRangeOverride',
  // 在别的工地还开着班（工地锁定要求同时只能有一个班次）
  OPEN_SHIFT_ELSEWHERE: 'attendance.reasonOpenShiftElsewhere',
};

/** 工人选的「继续打卡」理由 → 文案。自写的说明原样显示，不进这张表。 */
export const PUNCH_OVERRIDE_KEY: Record<string, string> = {
  GPS_UNAVAILABLE: 'punchOverride.gpsUnavailable',
  INDOOR_OR_UNDERGROUND: 'punchOverride.indoorOrUnderground',
  WORKING_OUTSIDE_FENCE: 'punchOverride.workingOutsideFence',
  SITE_LOCATION_WRONG: 'punchOverride.siteLocationWrong',
  PHONE_ISSUE: 'punchOverride.phoneIssue',
  OFFSITE_TASK: 'punchOverride.offsiteTask',
  OTHER: 'punchOverride.other',
};
